export const projectIdSmartPlanning = id => ({
  type: 'PROJECT_ID_SMART_PLANNING',
  id
})
